import type React from "react";
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { MUISelect } from "shared/atoms/MUI";
import type { Language, Market } from "types";
import { LanguageTypes } from "types";
import type { ValidLocale } from "types/validLocale";
import { getLngDropdownOpts } from "utils/locale/getLngDropdownOpts";
import { getStorageValue, setStorageValue } from "utils/storage";
import { translateLanguage } from "utils/translations";

export const LanguageDropdown: React.FC = () => {
  // NOTE: remove the splitting when dropdown values match available locales for the region
  const defaultLng = (getStorageValue("language")?.split("-")[0] || LanguageTypes.en) as Language;
  const [language, setLanguage] = useState(defaultLng);

  const { i18n } = useTranslation();

  const REGION = i18n.language.split("-")[1] as Market;

  useEffect(() => {
    // NOTE: remove once the dropdown values match the available locales
    const locale = `${language}-${REGION}`;
    if (language && locale !== i18n.language) {
      setStorageValue("language", locale as ValidLocale);
      i18n.changeLanguage(locale);
    }
  }, [language]);

  const dropdownOptions = getLngDropdownOpts(REGION, language);
  if (!dropdownOptions) {
    return null;
  }

  return (
    <MUISelect
      value={language}
      onChange={event => {
        setLanguage(event.target.value as Language);
      }}
      options={dropdownOptions.map(option => ({
        label: translateLanguage(option.value),
        value: option.value,
      }))}
      size="small"
      sx={{
        minWidth: 120,
      }}
    />
  );
};
